// extracted by mini-css-extract-plugin
export default {"eventsGrid":"Events_eventsGrid__APFIK","tableHeader":"Events_tableHeader__PMTb4"};